import { render, staticRenderFns } from "./AuthTemplate.vue?vue&type=template&id=d10698a0&scoped=true&"
import script from "./AuthTemplate.vue?vue&type=script&lang=js&"
export * from "./AuthTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AuthTemplate.vue?vue&type=style&index=0&id=d10698a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10698a0",
  null
  
)

export default component.exports